export default __webpack_public_path__ + "static/media/restaurant-logo.7db98fe3.svg";